var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfShowPassword = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  className: "dd-privacy-hidden"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "lf-show-password_svg__a",
  cx: 15,
  cy: 15,
  r: 15
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#lf-show-password_svg__a"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.32 12c-1.654 0-3 1.345-3 3s1.346 3 3 3c1.656 0 3-1.345 3-3s-1.344-3-3-3Zm-.227 2.11a.689.689 0 0 0-.683.683h-.993c.02-.93.766-1.676 1.676-1.676v.993Z",
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.424 14.38C23.41 13.116 19.79 9 15.321 9c-4.47 0-8.09 4.117-9.104 5.38a.995.995 0 0 0 0 1.24C7.231 16.884 10.852 21 15.321 21c4.469 0 8.09-4.117 9.103-5.38a.995.995 0 0 0 0-1.24Zm-9.103 4.965a4.344 4.344 0 1 1-.001-8.689 4.344 4.344 0 0 1 0 8.689Z",
  fill: "#405B73"
})))));
export default SvgLfShowPassword;